<template>
  <show-news v-if="$route.query.id !== undefined"></show-news>
  <news-list v-else></news-list>
</template>

<script>
import NewsList from "./news/NewsList.vue";
import ShowNews from "./news/ShowNews.vue";

export default {
  components: {
    "news-list": NewsList,
    "show-news": ShowNews
  }
};
</script>
